<!-- 
  Avatar Component Template
  
  Implements content fallback chain: Image → Initials → Icon
  Uses Angular @if/@defer control flow for conditional rendering
-->

<!-- Image Content (Priority 1) -->
@if (displayContent() === 'image') {
  @defer (prefetch on idle) {
    <img [alt]="alt() || computedAriaLabel()" [src]="src()!" (error)="onImageError()" />
  } @placeholder {
    <!-- Show initials while image loads -->
    @if (initials()) {
      <span>{{ truncatedInitials() }}</span>
    } @else {
      <!-- Fallback to icon while loading -->
      <ng-content select="[hxAvatarIcon]" />
    }
  }
}

<!-- Initials Content (Priority 2) -->
@if (displayContent() === 'initials') {
  <span>{{ truncatedInitials() }}</span>
}

<!-- Icon Content (Priority 3 - Fallback) -->
@if (displayContent() === 'icon') {
  <ng-content select="[hxAvatarIcon]">
    <!-- Default user icon if no custom icon projected -->
    <hx-icon fontIcon="person"></hx-icon>
  </ng-content>
}
